// helpers/tracking/getTrackingPath.ts

/**
 * Liefert den logischen Routen-Pfad für Tracking-Gates.
 *
 * Der Vue-Router läuft im Hash-Modus (vanilla.mymusicschool.de/#/bewerben) –
 * window.location.pathname ist dort immer "/". Deshalb den Pfad aus dem
 * Hash extrahieren und pathname nur als Fallback (History-Modus) nutzen.
 */
export function getTrackingPath(): string {
    if (typeof window === 'undefined') return '/';
    try {
        const hash = window.location.hash; // z.B. "#/bewerben?foo=bar"
        if (hash.startsWith('#/')) {
            return hash.slice(1).split('?')[0];
        }
    } catch {
        // noop
    }
    return window.location.pathname;
}
